var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-checkbox',_vm._b({class:{'rounded-box': _vm.rounded},attrs:{"checked-icon":"fl:check_fill_square","color":_vm.color,"label":_vm.label,"value":_vm.value,"size":_vm.size,"dense":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},'q-checkbox',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }